(ns ui.sticker-dialogs.question
  "The Replicant 'ask me a question' sticker dialog with a preview in
   the Instagram look."
  (:require [clojure.string :as str]
            [storrito.editor.sticker-design :as sticker-design]
            [storrito.editor.sticker-util :as sticker-util]
            [ui.sticker-dialogs.actions :as actions]
            [ui.sticker-dialogs.emoji-picker :as emoji-picker]
            [ui.sticker-dialogs.model :as model]
            [ui.sticker-dialogs.ui :as ui]))

(def sticker-shadow
  "0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)")

(def placeholder
  "Your question")

(def question-id
  "sticker-question-text")

(defn px
  "Scales the Instagram sticker measures (of a 695px wide sticker) to
   the 350px wide preview."
  [size]
  (str (* (/ 350 695) size) "px"))

(defn initial-state
  [{:keys [data]}]
  {:question (or (:question data) "")
   :background-color (or (:background-color data) "#ffffff")
   :text-color (or (:text-color data) "#000000")})

(defn submit-data
  [dialog]
  (when (seq (:question dialog))
    [:question-sticker "Question Sticker"
     (select-keys dialog [:question :background-color :text-color])]))

(defn preview
  [{:keys [question background-color text-color]}]
  [:div.relative.flex.flex-col.justify-between.items-center
   {:style {:box-shadow sticker-shadow
            :width (px 770)
            :min-height (px 407)
            :border-radius (px 29)
            :background-color background-color}}
   [:div.absolute.flex.justify-center.self-center
    {:style {:background-color background-color
             :border-radius "100%"
             :width (px 126)
             :height (px 126)
             :box-shadow "0 -5px 5px -3px rgba(0,0,0,.2)"
             :top (px (/ 126 -2))}}
    [:img.self-center
     {:src "/img/anonymous.png"
      :style {:background-color (sticker-util/shadow-color background-color)
              :border-radius "100%"
              :width (px 110)
              :height (px 110)}}]]
   [:div.font-bold.text-center
    {:style {:user-select "none"
             :max-height "123px"
             :min-height "50px"
             :overflow "hidden"
             :font-size (px 55)
             :font-family "Roboto"
             :word-break "break-word"
             :white-space "pre-wrap"
             :color text-color
             :margin (str/join " " [(px 110) (px 40) (px 10) (px 40)])}}
    (if (ui/blank? question) placeholder question)]
   [:div.relative.flex.flex-col.justify-center.items-center
    {:style {:user-select "none"
             :width (px 682)
             :min-height (px 140)
             :border-radius (px 20)
             :color (sticker-util/darken text-color 25)
             :background-color (sticker-util/shadow-color background-color)
             :margin-top (px 44)
             :margin-bottom (px 46)}}
    "Write something ..."]])

(defn panel
  [dialog]
  [:div.flex.flex-col
   {:style {:margin "20px"}}
   (ui/title "QUESTIONS" (merge {:font-family "AvenyT"}
                                (ui/gradient-text-style "#bc00af" "#f60008")))
   [:form.m-0.flex.flex-col.items-center
    {:on {:submit [[:js/prevent-default]
                   [:sticker-dialog/submit]]}}
    [:div.relative.max-w-full
     {:style {:width (px 770)}}
     [:label.font-bold.mb-1 "Enter your question:"]
     [:div.relative
      (ui/text-field dialog
                     {:tag :textarea
                      :field :question
                      :dom-id question-id
                      :rows 3
                      :placeholder placeholder
                      :autofocus? true
                      :class ["block" "border" "border-gray-300" "rounded" "p-2" "pr-10" "w-full" "resize-none"]})
      (ui/emoji-button {:field :question
                        :dom-id question-id
                        :class ui/emoji-button-inside-css})]
     (emoji-picker/panel dialog :question)]
    (ui/color-palette {:colors (vals sticker-design/question-colors)
                       :value (:background-color dialog)
                       :action-fn (fn [color]
                                    [[:sticker-dialog/assoc
                                      :background-color color
                                      :text-color (model/text-color-for color)]])})
    [:div.mt-6 (preview dialog)]
    [:p.mt-3 ui/instagram-note]
    [:div.mt-4.w-full.justify-center.flex
     (ui/primary-button {:type "submit"
                         :disabled (ui/blank? (:question dialog))}
                        "Add Questions")]]])

(defn render
  [state]
  (when-let [dialog (actions/dialog state)]
    (panel dialog)))

(def modal
  {:modal-id :modals/editor2-question-modal
   :on-load (fn [_state] [[:sticker-dialog/init :question]])
   :sticker/kind :question
   :sticker/single-asset-type :question-sticker
   :sticker/initial-state #'initial-state
   :sticker/submit-data #'submit-data
   :render #'render})

(def register
  [modal])
